import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Form } from '@dex/bubl-dash/src/lib/functions/useForm';
import Line from '@dex/bubl-dash/src/lib/components/Line/Line';
import Button, { ButtonRow } from '@dex/bubl-dash/src/lib/components/Button/Button';
import FieldText from '@dex/bubl-dash/src/lib/components/Fields/FieldText';
import FieldTextArea from '@dex/bubl-dash/src/lib/components/Fields/FieldTextArea';
import FieldRadio from '@dex/bubl-dash/src/lib/components/Fields/FieldRadio';
import FieldRelationship from '@dex/bubl-dash/src/lib/components/Fields/FieldRelationship';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';

const HostRequestsCreateEditForm: React.FC<any> = (props: any) => {

    const { form, process, handleSubmit } = props;

    const app = useApp();

    const manageGlobal = app.userCan(['manageGlobal'], false);

    // eslint-disable-next-line
    let data = props.data || {};

    return useMemo(() => (

        <Panel
            heading={"Request Details"}
        >

            <Form
                form={form}
                onSubmit={handleSubmit}
                loading={process.loading}
            >

                <Row gutter={8} edge={true}>

                    {manageGlobal &&
                        <Col col={{ xs: 24 }}>

                            <FieldRelationship
                                form={form}
                                label={"Host"}
                                name='hostId'
                                required={true}
                                preload={true}
                                endpoint={'Hosts'}
                                defaultValue={form.defaults.hostId}
                            />

                        </Col>
                    }

                    <Col col={{ xs: 24, md: 12 }}>

                        <FieldRadio
                            form={form}
                            label={"Property Type"}
                            name='propertyType'
                            required={true}
                            defaultValue={form.defaults.propertyType}
                            options={[
                                { value: "League", label: "League" },
                                { value: "CampSessionGroup", label: "Camp" },
                                { value: "PickupSessionGroup", label: "Pick Up" }
                            ]}
                        />

                    </Col>

                    {form.values.propertyType &&
                        <Col col={{ xs: 24, md: 12 }}>

                            <FieldRelationship
                                key={form.values.hostId}
                                form={form}
                                label={"Property"}
                                name='propertyId'
                                required={true}
                                preload={true}
                                endpoint={form.values.propertyType}
                                defaultValue={form.defaults.propertyId}
                                where={{ hostId: form.values.hostId }}
                            />

                        </Col>
                    }

                    <Col col={{ xs: 24, md: 24 }}>

                        <FieldText
                            form={form}
                            label="Subject"
                            name="subject"
                            required={true}
                            defaultValue={form.defaults.subject}
                        />

                    </Col>

                    <Col col={{ xs: 24, md: 24 }}>

                        <FieldTextArea
                            form={form}
                            label="Message"
                            name="message"
                            required={false}
                            defaultValue={form.defaults.message}
                        />

                    </Col>

                </Row>

                <Line />

                <ButtonRow>
                    <Button
                        label={"Submit"}
                        loading={process.loading}
                    />
                    <Button
                        label={"Reset"}
                        type={"faded"}
                        onClick={form.reset}
                    />
                </ButtonRow>

            </Form>

        </Panel>


    ), [props]);

}

export default HostRequestsCreateEditForm;
